import SectionFeatures from './SectionFeatures.container';

export default SectionFeatures;
